import i18n from './../../../i18n'


const dashboardTopItemTblHdr = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "title", label: "Title", thClass: 'thead-themed', sortable: true},
    { key: "type", label: "Type", thClass: 'thead-themed'},
    { key: "category", label: "Category", thClass: 'thead-themed'},
    { key: "amount", label: "SubTotal", thClass: 'thead-themed', sortable: true},
]

const dashboardTopSpendingMemberTblHdr = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "name", label: "Name", thClass: 'thead-themed', sortable: true},
    { key: "mobile", label: "Mobile", thClass: 'thead-themed'},
    { key: "noItem", label: "No. of Items", thClass: 'thead-themed', sortable: true},
    { key: "amount", label: "Sales Amount", thClass: 'thead-themed', sortable: true},
]

const memberTableHeaders = [
    { key: "index", label: "#", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "img", label: "Icon", thClass: 'thead-themed text-center', tdClass: 'text-center'},
    // { key: 2, label: "Outlet"},
    { key: "memberDisplayName", label: "Name", thClass: 'thead-themed', tdClass: 'align-middle',sortable: true},
    { key: "mobile", label: "Contact", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "bday", label: "Birthday", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "membership", label: "Membership Badges", thClass: 'thead-themed', tdClass: 'align-middle'}
];

const memberChangeMobileTblHdr = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "createDate", label: "Date", thClass: 'thead-themed', sortable: true},
    { key: "outlet", label: "Outlet", thClass: 'thead-themed'},
    { key: "memberDisplayName", label: "Name", thClass: 'thead-themed', sortable: true},
    { key: "oldMobile", label: "Old Mobile", thClass: 'thead-themed'},
    { key: "mobile", label: "New Mobile", thClass: 'thead-themed'}
];

const memberDeleteTblHdr = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "createDate", label: "Date", thClass: 'thead-themed', sortable: true},
    { key: "outlet", label: "Outlet", thClass: 'thead-themed'},
    { key: "memberDisplayName", label: "Name", thClass: 'thead-themed', sortable: true},
    { key: "mobile", label: "Mobile", thClass: 'thead-themed'},
];

const checklistTblHeaders = [
    {key: "index", label: "#", thClass: 'thead-themed'},
    {key: "title", label: i18n.t('table.header.title'), thClass: 'thead-themed', sortable: true},
    {key: "category", label: "Category", thClass: 'thead-themed', sortable: true},
    {key: "isEnable", label: "Enable/Disable", thClass: 'thead-themed'}
];

const outletTblHeaders = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "bizName", label: "Business Name", thClass: 'thead-themed', sortable: true},
    { key: "location", label: "Location", thClass: 'thead-themed', sortable: true},
    { key: "city", label: "City", thClass: 'thead-themed', sortable: true},
    { key: "username", label: "User Name", thClass: 'thead-themed', sortable: true},
    { key: "mobile", label: "Contact", thClass: 'thead-themed'},
    { key: "isEnable", label: "Enabled/Disabled", thClass: 'thead-themed', tdClass: 'text-center'},
    { key: "action", label: "Action", thClass: 'thead-themed', tdClass: 'text-center'}
];

const staffTblHeaders = [
    { key: "icon", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center'},
    { key: "name", label: "Name", thClass: 'thead-themed', sortable: true},
    { key: "mobile", label: "Contact", thClass: 'thead-themed'},
    { key: "online", label: "Show for Online", thClass: 'thead-themed text-center', tdClass: 'text-center'},
    { key: "work", label: "Show for Worksheet", thClass: 'thead-themed text-center', tdClass: 'text-center'},
    { key: "appt", label: "Show for Appointment", thClass: 'thead-themed text-center', tdClass: 'text-center'},
    { key: "gallery", label: "Gallery", thClass: 'thead-themed text-center', tdClass: 'text-center'}
];

const stockTblHeaders = [
    { id: "index", text: "#"},
    { id: "name", text: "Name"},
    { id: "action", text: "Action"},
    { id: "category", text: "Category"},
    { id: "folder", text: "Sub-category"},
    { id: "cost", text: "Cost"},
    { id: "price", text: "Price"},
    { id: "quantity", text: "Quantity"},
    { id: "total", text: "Total Price"},
    { id: "balance", text: "Balance"},
    { id: "inventory", text: "Inventory"},
];

const stockBalanceTblHeaders = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "title", label: "Name", thClass: 'thead-themed', sortable: true},
    { key: "category", label: "Category", thClass: 'thead-themed', sortable: true},
    { key: "folderID", label: "Sub-category", thClass: 'thead-themed', sortable: true},
    { key: "price", label: "Price", thClass: 'thead-themed', sortable: true},
    { key: "basePrice", label: "Cost", thClass: 'thead-themed', sortable: true},
    { key: "balance", label: "Balance", thClass: 'thead-themed', sortable: true},
    { key: "priceInventory", label: "Price Inventory", thClass: 'thead-themed', sortable: true},
    { key: "costInventory", label: "Cost Inventory", thClass: 'thead-themed', sortable: true},
    { key: "action", label: "Action", thClass: 'thead-themed'},
];

const inventoryTblHeaders = [
    { id: "index", text: "#"},
    { id: "name", text: "Name"},
    { id: "inDate", text: "Stock In Date"},
    { id: "outDate", text: "Stock Out Date"}
];
 
const discountItemTblHeaders = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "itemID", label: "Item ID", thClass: 'thead-themed', sortable: true},
    { key: "title", label: "Title", thClass: 'thead-themed', sortable: true},
    { key: "price", label: "Price", thClass: 'thead-themed', sortable: true},
    { key: "category", label: "Category", thClass: 'thead-themed'},
    { key: "subCategory", label: "Sub-Category", thClass: 'thead-themed'},
    { key: 6, label: "Enable/Disable", thClass: 'thead-themed'},
]

const itemSubTblHeader = [
    { key: "index", label: "#", thClass: 'thead-themed'},
    { key: "folderID", label: "Sub-Category ID", thClass: 'thead-themed', sortable: true},
    { key: "title", label: "Title" , thClass: 'thead-themed', sortable: true},
    { key: "category", label: "Category", thClass: 'thead-themed' },
    { key: "isEnable", label: "Enable/Disable", thClass: 'thead-themed' },
]

const productItemTblHeaders = [
    { key: "index", label: "#", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "img", label: "Image", thClass: 'thead-themed', tdClass: 'width-12'},
    { key: "itemID", label: "Item ID", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    { key: "title", label: "Title", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    { key: "price", label: "Price", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    { key: "basePrice", label: "Base Price", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    { key: "category", label: "Category", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "subCategory", label: "Sub-Category", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "isEnable", label: "Enable/Disable", thClass: 'thead-themed', tdClass: 'align-middle text-center'},
    { key: "gallery", label: "Gallery", thClass: 'thead-themed', tdClass: 'align-middle text-center'},
]

const serviceItemTblHeaders = [
    { key: "index", label: "#", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "img", label: "Image", thClass: 'thead-themed', tdClass: 'width-12'},
    { key: "itemID", label: "Item ID", thClass: 'thead-themed', sortable: true, tdClass: 'align-middle'},
    { key: "title", label: "Title", thClass: 'thead-themed', sortable: true, tdClass: 'align-middle'},
    { key: "price", label: "Price", thClass: 'thead-themed', sortable: true, tdClass: 'align-middle'},
    { key: "basePrice", label: "Base Price", thClass: 'thead-themed', sortable: true, tdClass: 'align-middle'},
    { key: "category", label: "Category", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "subCategory", label: "Sub-Category", thClass: 'thead-themed', tdClass: 'align-middle'},
    { key: "duration", label: "Duration", thClass: 'thead-themed', sortable: true, tdClass: 'align-middle'},
    { key: "isEnable", label: "Enable/Disable", thClass: 'thead-themed', tdClass: 'align-middle text-center'},
    { key: "isOnline", label: "Online", thClass: 'thead-themed', tdClass: 'align-middle text-center'},
    { key: "gallery", label: "Gallery", thClass: 'thead-themed', tdClass: 'align-middle text-center'}
]

const serviceSetupTblHeaders = [
    { id: "index", text: "#"},
    { id: "title", text: "Title"},
    { id: "price", text: "Price"},
    { id: "category", text: "Category"},
    { id: "isOnline", text: "Online"}
]

const commissionItemGroupTblHeaders = [
    { id: "index", text: "#"},
    { id: "title", text: ""},
    // { id: "outlet", text: "Outlet"},
    { id: "position", text: "Position"},
    { id: "staff", text: "Staff"},
    { id: "amount", text: "Amount"},
    { id: "effort", text: "Effort"},
    { id: "percentage", text: "Effort %"},
    { id: "fee", text: "Fee"},
    { id: "action", text: "Action"}
]

const commissionTypeTblHeader = [
    { id: "index", text: "#"},
    { id: "", text: ""},
    { id: "totalQuantity", text: "Total Quantity"},
    { id: "totalEffort", text: "Total Effort"},
    { id: "totalFee", text: "Total Fee"}
]

const commissionCategoryTblHeader = [
    { id: "index", text: "#"},
    { id: "", text: ""},
    { id: "price", text: "Item Price"},
    { id: "effort", text: "Effort"},
    { id: "credit", text: "Credit"},
    { id: "cEffort", text: "Effort"},
    { id: "package", text: "Package"},
    { id: "pEffort", text: "Effort"},
    { id: "totalEffort", text: "Total Effort"},
    { id: "totalFee", text: "Total Fee"}
]

const commissionItemStaffEditTblHeader = [
    { id: "index", text: "#"},
    { id: "editStaff", text: "Staff"},
    { id: "editEffort", text: "Effort"},
    { id: "editPercentage", text: "Effort %"},
    { id: "editFee", text: "Fee"}
]

const salesReportItemTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "title", label: "Title", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "price", label: "Price", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "discount", label: "Discount", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "outstanding", label: "Outstanding", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "tax", label: "Tax", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "taxType", label: "Type of Tax", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "subTotal", label: "Subtotal", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    // {key: "action", label: "Action"},
]

const salesReportDateTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "service", text: "Service"},
    {id: "product", text: "Product"},
    {id: "package", text: "Package"},
    {id: "discount", text: "Discount"},
    {id: "outstandings", text: "Outstanding Collection"},
    {id: "total", text: "Total"},
]

const commissionStaffTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "service", text: "Service"},
    {id: "product", text: "Product"},
    {id: "package", text: "Package"},
    {id: "outstandings", text: "Outstanding Collection"},
    {id: "total", text: "Total"},
]

const rewardItemTblHdr = [
    {id: "index", text: "#"},
    {id: "qrcode", text: "QR Code"},
    {id: "reward", text: "Reward"},
    {id: "duration", text: "Duration"},
    {id: "Progress", text: "Progress"},
    {id: "isEnable", text: "Enable/Disable"},
    {id: "action", text: "Action"},
]

const broadcastItemTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "createDate", label: "Date", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "image", label: "Broadcast Image", thClass: 'thead-themed', tdClass: 'text-center'},
    {key: "topic", label: "Topic", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "caption", label: "Caption", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "totalLikes", label: "Like", thClass: 'thead-themed', tdClass: 'align-middle width-6', sortable: true},
    {key: "totalComments", label: "Comment", thClass: 'thead-themed', tdClass: 'text-center align-middle', sortable: true},
    {key: "rewardQR", label: "Reward QR", thClass: 'thead-themed', tdClass: 'text-center align-middle'},
    {key: "rewardPeriod", label: "Reward Period", thClass: 'thead-themed', tdClass: 'text-center align-middle', sortable: true},
    {key: "action", label: "Action", thClass: 'thead-themed', tdClass: 'text-center align-middle'},
]

const broadcastTargetTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed'},
    {key: "memberDisplayName", label: "Name", thClass: 'thead-themed', sortable: true},
    {key: "mobile", label: "Mobile", thClass: 'thead-themed'},
    {key: "action", label: "Action", thClass: 'thead-themed text-center', tdClass: 'text-center'},
]

const creditReportListTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "orderID", text: "Order ID"},
    {id: "name", text: "Name"},
    {id: "mobile", text: "Mobile"},
    {id: "action", text: "Action"},
    {id: "amount", text: "Amount"},
    {id: "balance", text: "Balance"},
    {id: "outlet", text: "Outlet"},
    {id: "rollback", text: "Rollback"},
]

const creditReportSummaryTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "topup", text: "Top Up"},
    {id: "redeem", text: "Redeem"},
    {id: "balance", text: "Balance"},
]

const creditReportSummaryCustomerTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed'},
    {key: "memberDisplayName", label: "Name", thClass: 'thead-themed', sortable: true},
    {key: "mobile", label: "Mobile", thClass: 'thead-themed'},
    {key: "total", label: "Balance", thClass: 'thead-themed', sortable: true},
]

const outstandingsReportSummaryTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "outstandings", text: "Outstandings"},
    {id: "collection", text: "Collection"},
    {id: "balance", text: "Balance"},
]

const pointReportListTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "orderID", text: "Order ID"},
    {id: "name", text: "Name"},
    {id: "mobile", text: "Mobile"},
    {id: "action", text: "Action"},
    {id: "point", text: "Point"},
    {id: "balance", text: "Balance"},
    {id: "outlet", text: "Outlet"},
    {id: "rollBack", text: "Rollback"},
]

const bookingBlockListTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed'},
    {key: "createDate", label: "Date", thClass: 'thead-themed', sortable: true},
    {key: "mobile", label: "Mobile", thClass: 'thead-themed'},
    {key: "action", label: "Action", thClass: 'thead-themed text-center', tdClass: 'text-center'},
]

const voucherReportSummaryDateTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "signup", text: "Sign Up"},
    {id: "redeem", text: "Redeem"},
    {id: "expired", text: "Expired"},
]

const voucherReportSummaryVoucherTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed'},
    {key: "voucherName", label: "Voucher", thClass: 'thead-themed', sortable: true},
    {key: "total", label: "Balance", thClass: 'thead-themed', sortable: true},
]

const voucherReportSummaryExpiryTblHdr = [
    {id: "index", text: "#"},
    {id: "name", text: "Name"},
    {id: "mobile", text: "Mobile"},
    {id: "expiryDate", text: "Expiry Date"},
]

const voucherReportSummaryVoucherBalanceTblHdr = [
    {key: "index", label: "#"},
    {key: "memberDisplayName", label: "Name", sortable: true},
    {key: "mobile", label: "Mobile"},
    {key: "amount", label: "Amount", sortable: true},
    {key: "total", label: "Balance", sortable: true},
]

const voucherReportSummaryCustomerTblHdr = [
    {id: "index", text: "#"},
    {id: "voucher", text: "Voucher"},
    {id: "total", text: "Total"},
    {id: "amount", text: "Amount"},
]

const voucherReportListTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    {id: "voucher", text: "Voucher"},
    {id: "orderID", text: "Order ID"},
    {id: "action", text: "Action"},
    {id: "expDate", text: "Expiry Date"},
    {id: "outlet", text: "Sign Up Outlet"},
    {id: "redOutlet", text: "Redeem/Expired Outlet"},
]

const attendanceReportListTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed'},
    {key: "icon", label: "", tdClass: 'text-center', thClass: 'thead-themed'},
    {key: "name", label: "Name", thClass: 'thead-themed', sortable: true},
    {key: "username", label: "Username", thClass: 'thead-themed', sortable: true},
    {key: "outletID", label: "Outlet", thClass: 'thead-themed'},
    {key: "duration", label: "Working Hours", thClass: 'thead-themed', sortable: true},
    {key: "entryDate", label: "Clock In", thClass: 'thead-themed', sortable: true},
    {key: "exitDate", label: "Clock Out", thClass: 'thead-themed', sortable: true},
]

const userListTblHdr = [
    {id: "index", text: "#"},
    {id: "shopname", text: "Shop Name"},
    {id: "username", text: "Username"},
    {id: "mobile", text: "Mobile"},
    {id: "loginDate", text: "Login Date"},
    {id: "blockDate", text: "Block Date"},
    {id: "outlet", text: "Outlet"},
    {id: "action", text: "Action"},
]

const blockPermissionListTblHdr = [
    {id: "index", text: "#"},
    {id: "module", text: "Restricted Module"},
    {id: "action", text: "Action"},
]

const userOutletListTblHdr = [
    {id: "index", text: "#"},
    {id: "username", text: "Username"},
    {id: "bizName", text: "Business Name"},
    {id: "location", text: "Location"},
    {id: "city", text: "City"},
    {id: "contact", text: "Contact"},
    {id: "isEnable", text: "Enable/Disable"},
]

const rewardReportTblHdr = [
    {id: "index", text: "#"},
    {id: "date", text: "Date"},
    // {id: "outlet", text: "Outlet"},
    {id: "reward", text: "Reward"},
    {id: "name", text: "Name"},
    {id: "mobile", text: "Mobile"},
]

const paymentDateblHdr = [
    {id: "index", text: "#"},
    {id: "paymentMethods", text: "Payment Methods"},
    {id: "total", text: "Total"},
]

const paymentOrderTblHdr = [
    {key: "index", label: "#", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "createDate", label: "Date", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "receiptID", label: "Receipt Number", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "outlet", label: "Outlet", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "infoName", label: "Info Name", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
    {key: "mobile", label: "Mobile", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "paymentMethod", label: "Payment Method", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "amount", label: "Amount", thClass: 'thead-themed', tdClass: 'align-middle'},
    {key: "total", label: "Total", thClass: 'thead-themed', tdClass: 'align-middle', sortable: true},
]

const orderTblHdr = [
    {id: "date", text: "Date"},
    {id: "outlet", text: "Outlet"},
    {id: "staff", text: "Staff"},
    {id: "infoName", text: "Info Name"},
    {id: "mobile", text: "Mobile"},
    {id: "item", text: "Item"},
    {id: "amount", text: "Amount"},
    {id: "paymentMethod", text: "Payment Method"},
    {id: "tax", text: "Tax"},
    {id: "rounding", text: "Rounding"},
    {id: "total", text: "Total"}, 
]


export default{
    dashboardTopItemTblHdr: dashboardTopItemTblHdr,
    dashboardTopSpendingMemberTblHdr: dashboardTopSpendingMemberTblHdr,
    memberTableHeaders: memberTableHeaders,
    memberChangeMobileTblHdr: memberChangeMobileTblHdr,
    memberDeleteTblHdr: memberDeleteTblHdr,
    checklistTblHeaders: checklistTblHeaders,
    outletTblHeaders: outletTblHeaders,
    staffTblHeaders: staffTblHeaders,
    stockTblHeaders: stockTblHeaders,
    stockBalanceTblHeaders: stockBalanceTblHeaders,
    inventoryTblHeaders: inventoryTblHeaders,
    discountItemTblHeaders: discountItemTblHeaders,
    itemSubTblHeader: itemSubTblHeader,
    productItemTblHeaders: productItemTblHeaders,
    serviceItemTblHeaders: serviceItemTblHeaders,
    serviceSetupTblHeaders: serviceSetupTblHeaders,
    commissionItemGroupTblHeaders: commissionItemGroupTblHeaders,
    commissionTypeTblHeader: commissionTypeTblHeader,
    commissionCategoryTblHeader: commissionCategoryTblHeader,
    commissionItemStaffEditTblHeader: commissionItemStaffEditTblHeader,
    salesReportItemTblHdr: salesReportItemTblHdr,
    salesReportDateTblHdr: salesReportDateTblHdr,
    rewardItemTblHdr: rewardItemTblHdr,
    broadcastItemTblHdr: broadcastItemTblHdr,
    broadcastTargetTblHdr: broadcastTargetTblHdr,
    creditReportListTblHdr: creditReportListTblHdr,
    creditReportSummaryTblHdr: creditReportSummaryTblHdr, 
    creditReportSummaryCustomerTblHdr: creditReportSummaryCustomerTblHdr, 
    outstandingsReportSummaryTblHdr: outstandingsReportSummaryTblHdr, 
    pointReportListTblHdr: pointReportListTblHdr,
    bookingBlockListTblHdr: bookingBlockListTblHdr, 
    voucherReportSummaryDateTblHdr: voucherReportSummaryDateTblHdr,
    voucherReportSummaryVoucherTblHdr: voucherReportSummaryVoucherTblHdr, 
    voucherReportSummaryVoucherBalanceTblHdr: voucherReportSummaryVoucherBalanceTblHdr,
    voucherReportSummaryCustomerTblHdr: voucherReportSummaryCustomerTblHdr,
    voucherReportListTblHdr: voucherReportListTblHdr,
    attendanceReportListTblHdr: attendanceReportListTblHdr,
    voucherReportSummaryExpiryTblHdr: voucherReportSummaryExpiryTblHdr,
    userListTblHdr: userListTblHdr,
    blockPermissionListTblHdr: blockPermissionListTblHdr,
    userOutletListTblHdr: userOutletListTblHdr,
    rewardReportTblHdr: rewardReportTblHdr,
    paymentDateblHdr: paymentDateblHdr,
    paymentOrderTblHdr: paymentOrderTblHdr,
    orderTblHdr: orderTblHdr,
    commissionStaffTblHdr: commissionStaffTblHdr
}
